module.exports = __webpack_public_path__ + "img/icon_transport.d0242100.svg";